/* Sticky coupon popup: delayed reveal + dismiss-with-memory (localStorage). */
(function () {
  function init(el) {
    if (el.dataset.bound) return;
    el.dataset.bound = '1';

    var key = 'coupon_popup_' + (el.dataset.key || 'default');
    var days = parseInt(el.dataset.dismissDays || '7', 10);
    var delay = parseInt(el.dataset.delay || '3000', 10);
    var isEditor = el.dataset.editor === 'true';

    function show() { el.classList.add('is-visible'); }
    function hide() { el.classList.remove('is-visible'); }

    var closeBtn = el.querySelector('.coupon-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        hide();
        try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
      });
    }

    // In the theme editor: always show so the merchant can style it.
    if (isEditor) { show(); return; }

    var dismissedAt = 0;
    try { dismissedAt = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    if (days > 0 && dismissedAt && (Date.now() - dismissedAt) < days * 86400000) return;

    window.setTimeout(show, delay);
  }

  function boot() {
    var nodes = document.querySelectorAll('.coupon-popup');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when (re)added in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
